export function containerExist(divClass, iconClass, iconClassClose) {

    const divWithClassExists = document.querySelectorAll(
        "div." + divClass
    ).length > 0;

    if (divWithClassExists) {
        $("." + iconClass).show();
        $("." + iconClassClose).hide();
    } else {
        $("." + iconClass).hide();
        $("." + iconClassClose).show();
    }
}


export function autocomplete(inp, arr, viewAllLink) {
    /*the autocomplete function takes two arguments,
    the text field element and an array of possible autocompleted values:*/
    let currentFocus;
    /*execute a function when someone writes in the text field:*/
    inp.addEventListener("input", function (e) {
        let a, b, i, val = this.value;
        /*close any already open lists of autocompleted values*/
        closeAllLists();
        if (!val) { return false; }
        currentFocus = -1;
        /*create a DIV element that will contain the items (values):*/
        a = document.createElement("DIV");
        a.setAttribute("id", this.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items my-3");

        /*append the DIV element as a child of the autocomplete container:*/
        this.parentNode.appendChild(a);
        /*for each item in the array...*/
        for (i = 0; i < arr.length; i++) {
            /*check if the item starts with the same letters as the text field value:*/
            if (arr[i].value.substr(0, val.length).toUpperCase() == val.toUpperCase()) {
                /*create a DIV element for each matching element:*/

                let containerClass = "";
                if (i % 2 > 0) {
                    containerClass = "dp-bg-white";
                } else {
                    containerClass = "dp-bg-autocomplete";
                }

                let linkValue = document.createElement("a");
                linkValue.setAttribute("href", arr[i].link);
                linkValue.classList.add("link-dark");

                b = document.createElement("DIV");

                b.classList.add("d-flex");
                b.classList.add("align-items-center");
                b.classList.add("justify-content-between");
                b.classList.add("p-3");
                b.classList.add(containerClass);


                /*make the matching letters bold:*/
                b.innerHTML += "<div><span class='fw-bold'>" + arr[i].value.substr(0, val.length) + "</span>" + arr[i].value.substr(val.length) + "</div>";
                b.innerHTML += "<div class='fw-bold text-primary text-uppercase'>" + arr[i].category + "</div>";
                /*insert a input field that will hold the current array item's value:*/
                //b.innerHTML += "<input type='hidden' value='" + arr[i].value + "'>";
                /*execute a function when someone clicks on the item value (DIV element):*/
                /*b.addEventListener("click", function (e) {
                  /*insert the value for the autocomplete text field:*/
                //inp.value = this.getElementsByTagName("input")[0].value;
                /*close the list of autocompleted values,
                (or any other open lists of autocompleted values:*/
                //closeAllLists();});


                linkValue.appendChild(b);

                a.appendChild(linkValue);
            }
        }

        let buttonContainer = document.createElement("DIV");
        buttonContainer.classList.add("row");
        buttonContainer.classList.add("col-12");
        buttonContainer.classList.add("col-lg-12");
        buttonContainer.classList.add("align-items-center");
        buttonContainer.classList.add("p-4");


        let buttonContainerRow = document.createElement("DIV");
        buttonContainerRow.classList.add("d-flex");
        buttonContainerRow.classList.add("align-items-center");
        buttonContainerRow.classList.add("justify-content-center");

        let buttonContainerFlex = document.createElement("DIV");
        buttonContainerFlex.classList.add("m-2")

        let viewAll = document.createElement("a");
        viewAll.classList.add("btn");
        viewAll.classList.add("btn-primary");
        viewAll.setAttribute("href", viewAllLink);
        viewAll.innerHTML = "<div><span class='dp-button-text'>View all results (" + arr.length + ")</span><span class='material-symbols-outlined ms-3'>search</span></div>";

        buttonContainerFlex.appendChild(viewAll);
        buttonContainerRow.appendChild(buttonContainerFlex);

        buttonContainer.appendChild(buttonContainerRow);
        a.appendChild(buttonContainer);

    });
    /*execute a function presses a key on the keyboard:*/
    inp.addEventListener("keydown", function (e) {

        let x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(x);
        } else if (e.keyCode == 38) { //up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(x);
        } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
                /*and simulate a click on the "active" item:*/
                if (x) x[currentFocus].click();
            }
        }
    });


    function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = (x.length - 1);
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (const element of x) {
            element.classList.remove("autocomplete-active");
        }
    }
    function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        let x = document.getElementsByClassName("autocomplete-items");
        for (const element of x) {
            if (elmnt != element && elmnt != inp) {
                element.parentNode.removeChild(element);
            }
        }
    }
    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {
        closeAllLists(e.target);
    });
}

/*
 This is an example of how to call the autocomplete function

 instanziate an array containing objects with three string properties: value, category and link

    let countries = [
      {
        value: "Afghanistan",
        category: "Document",
        link: "http://www.google.it"
      },
      {
        value: "Albania",
        category: "Api",
        link: "http://www.google.it"
      },
      {
        value: "Algeria",
        category: "Solution",
        link: "http://www.google.it"
      }
    ];

 initiate the autocomplete function on the "myInput" element, and pass along the array as possible autocomplete values:
    autocomplete(document.getElementById("dp-input-item"), countries, "http://www.google.it");*/

export function closeAutoComplete(SearchInputReference) {
    SearchInputReference.value = ""
    $(".autocomplete-open").hide();
    $(".autocomplete-close").show();
}
